import React, { useState } from 'react';
import { InputBase } from '@material-ui/core';
import { borderColor } from './common';

const EAA_Input = ({
  hint = '請輸入',
  value = '',
  onChange = () => {},
  disabled = false,
  type = '',
  displayBorder = false,
  paddingLeft = 12,
  paddingRight = 12,
  marginRight = 50,
  unit = null,
  label = null,
  style = {},
  displayDisabledBorder = false,
}) => {
  const [over, setOver] = useState(false);
  const [focus, setFocus] = useState(false);
  const EndAdornment = () => unit ? <div style={{ color: 'gray', marginLeft: 8, whiteSpace: 'nowrap' }}>{unit}</div> : null;
  const StartAdornment = () => label ? <div style={{ color: 'color', marginLeft: 8, marginRight: 8, whiteSpace: 'nowrap' }}>{label}</div> : null;
  return (
    <div style={{ flex: 1, marginRight, ...style }}>
      <InputBase
        style={{
          backgroundColor: disabled ? '#ededed' : 'white',
          width: '100%',
          height: 46,
          fontSize: 16,
          letterSpacing: '0.15px',
          borderRadius: 14,
          paddingLeft,
          paddingRight,
          border: ((displayBorder || over || focus) && (!disabled || displayDisabledBorder)) ? `1px solid ${(over || focus) ? 'black' : borderColor}` : '',
        }}
        readOnly={disabled}
        placeholder={disabled ? '' : hint}
        inputProps={{ height: 44 }}
        value={value}
        onChange={e => { onChange(e.target.value); }}
        type={type}
        onMouseOver={() => disabled ? null : setOver(true)}
        onMouseOut={() => disabled ? null : setOver(false)}
        onBlur={() => disabled ? null : setFocus(false) }
        onFocus={() => disabled ? null : setFocus(true)}
        endAdornment={<EndAdornment />}
        startAdornment={<StartAdornment />}
        autoComplete={type === 'password' ? 'off' : 'on'}
      />
    </div>
  );
};

export default EAA_Input;
